import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/kontakt";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/contact")(
  enRouteOptions(routeOptions, {
    svPath: "/kontakt",
    title: 'Contact – Alkoholprovet',
    description: 'Questions about the Swedish alcohol serving licence test or your purchase? Email info@alkoholprovet.se or use the contact form.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
